import * as React from "react";

export const SalesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#F1F5F9"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 6.3v14.2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6.3z"
    ></path>
    <path
      stroke="#F1F5F9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m21 6.3-2.833-3.8H5.833L3 6.3M15.778 9.6c0 2.099-1.692 3.8-3.778 3.8S8.222 11.7 8.222 9.6"
    ></path>
  </svg>
);

export const CredentialsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.5 12.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11.5 15.5a3 3 0 0 0-6 0"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14 10h4M15 14h3"
    ></path>
  </svg>
);

export const TransfersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 12.5a6 6 0 0 1 6-6h14"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m19 3.5 3 3-3 3M22 11.5a6 6 0 0 1-6 6H2"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m5 20.5-3-3 3-3"
    ></path>
  </svg>
);

export const ContractIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 22V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h8"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="2"
      d="M7 6h9M7 10h9"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M7 14h5"
    ></path>
  </svg>
);

export const DotIcon = (props) => {
  const { color = "#068EC3", size = 6 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 6 7"
    >
      <circle cx="3" cy="3.5" r="3" fill={color} />
    </svg>
  );
};

export const ArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      stroke="#314158"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m6 12.5 4-4-4-4"
    ></path>
  </svg>
);
